import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { validateForm, validation } from '../../../utils/validation';
import { generalItemApi } from '../../../services/apis';
import { Input, Button, ValidationMessage } from '../../../component';

const AddTempGeneralItem = ({
  generalItemType = '',
  inputsLabel = { fa: 'language.persian', en: 'language.english' },
  intl = {},
  setToastify = () => {},
  closeModal = () => {},
}) => {
  const [tourTypeNameEn, setTourTypeNameEn] = useState('');
  const [tourTypeNameFa, setTourTypeNameFa] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState({
    tourTypeNameEn: [],
    tourTypeNameFa: [],
  });

  useEffect(() => {
    fetchTourTypeData();
  }, []);

  const fetchTourTypeData = async () => {
    try {
      const {
        payload: { data },
      } = await generalItemApi.getAll({
        pageNumber: 1,
        itemPerPage: 1,
        data: {
          filter: {
            type: generalItemType,
          },
          sort: { code: 'desc' },
        },
      });
      let code = `${+data[0]?.code + 1}`.padStart(2, 0);
      setCode(code);
    } catch ({ message }) {
      setToastify({ type: 'danger', message });
    }
  };

  const handleValidation = () => {
    const { error, result } = validateForm({
      tourTypeNameFa: validation?.persian(tourTypeNameFa)?.required()?.errors,
      tourTypeNameEn: validation?.english(tourTypeNameEn)?.required()?.errors,
    });
    return { result, error };
  };

  const onSubmit = async () => {
    const { result } = handleValidation();
    if (result) {
      try {
        const { status } = await generalItemApi?.insertTemp({
          name: { en: tourTypeNameEn, fa: tourTypeNameFa },
          description: { en: tourTypeNameEn, fa: tourTypeNameFa },
          type: generalItemType,
          code,
        });
        if (status === 200) {
          setToastify({
            type: 'success',
            message: 'tour.tourtypeinsertsuccess',
          });
          closeModal();
        } else
          setToastify({ type: 'danger', message: 'tour.tourtypeinserterror' });
      } catch ({ message }) {
        setToastify({ type: 'danger', message });
      }
    }
  };

  return (
    <form
      id="general-item-form"
      name="general-item-form"
      onSubmit={(event) => event.preventDefault()}
      className="w-100 d-flex align-items-center justify-content-end flex-wrap"
    >
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="tourTypeNameFa"
          label={intl.formatMessage({
            id: inputsLabel?.fa,
          })}
          value={tourTypeNameFa}
          onChange={({ target }) => {
            const { value } = target;
            setTourTypeNameFa(value);
            setError((error) => {
              return {
                ...error,
                tourTypeNameFa: validation?.persian(value)?.required()?.errors,
              };
            });
          }}
          iconUrl={null}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={error?.tourTypeNameFa} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="tourTypeNameEn"
          label={intl.formatMessage({
            id: inputsLabel?.en,
          })}
          value={tourTypeNameEn}
          onChange={({ target }) => {
            const { value } = target;
            setTourTypeNameEn(value);
            setError((error) => {
              return {
                ...error,
                tourTypeNameEn: validation?.english(value)?.required()?.errors,
              };
            });
          }}
          iconUrl={null}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={error?.tourTypeNameEn} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Button
          id="general-item-submit"
          name="general-item-submit"
          width="w-100 px-0 py-4"
          type="submit"
          disabled={!handleValidation().result}
          label={intl.formatMessage({
            id: 'tour.submittourtype',
          })}
          onClick={onSubmit}
        />
      </fieldset>
    </form>
  );
};

AddTempGeneralItem.propTypes = {
  generalItemType: PropTypes?.string,
  inputsLabel: PropTypes?.object,
  intl: PropTypes?.object,
  setToastify: PropTypes?.func,
  closeModal: PropTypes?.func,
};

export default AddTempGeneralItem;
